import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as Classes from '../classes/models.classes';
import { ReactionHubService } from './reaction-hub.service';
import { patchReactionCountsInTree, patchReactionCountsOnPost } from './post-reaction-patch';

@Injectable({ providedIn: 'root' })
export class PostReactionRealtimeService {
  constructor(private reactionHub: ReactionHubService) {}

  /**
   * Keeps reaction counts in sync for every connected client when the server broadcasts updates.
   * Call from ngOnInit with the same DestroyRef as the component.
   * Optional rootPostGetter: post detail page root post (not in the replies array).
   */
  wirePostList(
    postsGetter: () => Classes.ShortsPosts[] | undefined,
    destroyRef: DestroyRef,
    rootPostGetter?: () => Classes.ShortsPosts | undefined
  ): void {
    this.reactionHub.start();
    this.reactionHub.reactionCounts$
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(msg => {
        patchReactionCountsInTree(postsGetter(), msg.postId, msg);
        if (rootPostGetter) {
          patchReactionCountsOnPost(rootPostGetter(), msg.postId, msg);
        }
      });
  }
}
